// ============================================================
// draftCards — 下書きカードの状態（2026-11-03 A9）
//
// AI が send_reservation_email で送っても、カードは「未送信」のまま残っていた。カードを送信済みにするのは
// ［送信］ボタンの経路だけで、毎ターンの【システム】は未送信のカードから「未送信の下書き #N」と添えるため、
// AI は送れたのに「カードの［送信］で送られます」と答えた（10/16〜22 のレビュー A9。二重送信の恐れ）。
// ============================================================

import type { AgentUiMessage } from './types';

/** その下書きのカードを送信済みにする（ツールで送れたとき）。カードが無ければそのまま返す */
export function markDraftCardSent(messages: AgentUiMessage[], draftId: number, sentTo: string): AgentUiMessage[] {
  return messages.map((m: any) => (m.kind === 'mail_draft' && Number(m.draftId) === Number(draftId) && (m.state ?? 'pending') === 'pending'
    ? { ...m, state: 'sent', note: `${sentTo} へ送信しました（AI が送信）` }
    : m));
}

/** ツールで送れたときに AI へ返す結果に足す一文 */
export const SENT_BY_TOOL_NOTE = 'この下書きは送信済み（下書きカードも送信済みに変えた）。'
  + '「カードの［送信］で送られます」と案内しない・同じ下書きを再送しない。';
